module.exports = __webpack_public_path__ + "media/images/logo/thermo-fdaeeb6dc138966fc401e71b4f4fa136.svg";